export default __webpack_public_path__ + "static/rs-c9ae62f6cd9f334dc7f36ac440e61c3a.svg";